import { useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 50;
  display: flex;
  min-width: 3.5rem;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 0.25rem;
  border: 1px solid ${(props) => props.theme.headerOutline};
  background-color: ${(props) => props.theme.headerBackground};
  padding: 0.25rem 0.75rem;
  font-size: 10px;
  line-height: 16px;
  box-shadow: -3px -3px 10px 2px #14141423;

  &:hover .slot-name {
    opacity: 0;
  }

  &:hover .actions {
    opacity: 1;
  }
`;

const SlotName = styled.div`
  color: ${(props) => props.theme.mediumText};
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
`;

const ActionsContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
`;

const IconButton = styled.div`
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 1;
  }
`;

const getSlotNameQueryParam = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("slot");
};

const getRoutingQueryParam = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("x-ms-routing-name");
};

const getSlotNameLocalStorage = () => {
  return localStorage.getItem("slot");
};

const removeSlot = () => {
  localStorage.removeItem("slot");
  window.location.href = `${window.location.origin}?x-ms-routing-name=self`;
};

const GITHUB_REPO_URL = "https://github.com/quorumcyber-clarity/clarity-internal";

export const SlotSwitcher = () => {
  const slotQueryParam = getSlotNameQueryParam();

  // Set slot name in local storage if present and redirect to slot
  useEffect(() => {
    if (slotQueryParam) {
      localStorage.setItem("slot", slotQueryParam);
      window.location.href = `${window.location.origin}?x-ms-routing-name=${slotQueryParam}`;
    }

    // Clear routing param if present
    if (getRoutingQueryParam()) window.location.href = window.location.origin;
  }, [slotQueryParam]);

  const slot = getSlotNameLocalStorage();

  if (!slot) return null;

  const pullRequestNumber = slot.split("-")[1];
  const githubLink = `${GITHUB_REPO_URL}/pull/${pullRequestNumber}`;

  return (
    <Container>
      <SlotName className="slot-name">{slot}</SlotName>
      <ActionsContainer className="actions">
        <IconButton title="Reset" onClick={removeSlot}>
          🗑️
        </IconButton>
        <a href={githubLink} target="_blank" rel="noreferrer">
          <IconButton title="GitHub">🔗</IconButton>
        </a>
      </ActionsContainer>
    </Container>
  );
};